// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_AgIa6 {
  padding-bottom: '16px';
}
.input_jjYAr {
  max-width: 100%;
}
.fileName_lyH8z {
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/imagine/forms/file/Uploader.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":[".container {\n  padding-bottom: '16px';\n}\n.input {\n  max-width: 100%;\n}\n.fileName {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_AgIa6`,
	"input": `input_jjYAr`,
	"fileName": `fileName_lyH8z`
};
export default ___CSS_LOADER_EXPORT___;
